import { Link } from "react-router-dom";
import { Button } from "antd";

/**
 * "Login" control that impersonates a brand user and opens the Brand Portal.
 *
 * Renders a real <a> link to the URL-addressable /brands/:userId/login route
 * (PROD-1989) so admins can right-click → copy URL or ctrl-click → open in a
 * new tab. The impersonation flow itself runs in BrandLoginRedirect.
 */
export const LoginAsButton = ({ userId, disabled, ...btnProps }) => {
    if (disabled) {
        return (
            <Button {...btnProps} disabled>
                Login
            </Button>
        );
    }

    return (
        <Link to={`/brands/${userId}/login`}>
            <Button {...btnProps}>Login</Button>
        </Link>
    );
};
